module.exports = __webpack_public_path__ + "static/media/d11c403adc5b8b73.22b9042b.png";